module.exports = __webpack_public_path__ + "static/img/caseImg10.7d3e0e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg10.jpg
// module id = 9qP5
// module chunks = 0